import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaGraduationCap, FaHospital, FaStar, FaUsers, FaUniversity,
  FaMicroscope, FaHandshake, FaAward, FaCompass, FaGlobe,
  FaArrowRight, FaPhone, FaUserMd, FaCheckCircle
} from 'react-icons/fa';
import doctorImg from '../assets/Doctor.jpg';

const reasons = [
  { icon: <FaUniversity size={28} />, title: 'AIIMS-Trained Neurologist', desc: "DM Neurology from India's most prestigious medical institution — the highest neurological qualification available in the country." },
  { icon: <FaMicroscope size={28} />, title: 'Advanced Diagnostics',       desc: 'In-clinic EEG, NCS/EMG, and neuroimaging interpretation — comprehensive diagnostics under one roof, without referrals.' },
  { icon: <FaHandshake size={28} />,  title: 'Patient-First Approach',     desc: "Every patient receives unhurried, compassionate care — with clear explanations, personalised treatment, and long-term follow-up." },
  { icon: <FaAward size={28} />,      title: 'Super-Specialist Expertise', desc: 'Triple qualification — MBBS, MD Internal Medicine, and DM Neurology — ensuring the deepest level of neurological expertise.' },
  { icon: <FaCompass size={28} />,    title: 'Evidence-Based Treatment',   desc: 'Every treatment plan is grounded in the latest clinical research and international neurology guidelines — not guesswork.' },
  { icon: <FaGlobe size={28} />,      title: 'Serving All of Maharashtra', desc: 'Patients travel from Nashik, Aurangabad, Mumbai and beyond — trusting Dr. Naik for conditions others could not diagnose.' },
];

const milestones = [
  { year: 'MBBS',  place: 'BJMC, Pune',           note: 'Foundation in medicine' },
  { year: 'MD',    place: 'Internal Medicine',    note: 'Pune University' },
  { year: 'DM',    place: 'AIIMS',                note: 'Super-specialist Neurology' },
  { year: '10+',   place: 'Years of Practice',    note: 'Naik Neuro Clinic, Nashik' },
];

const expertise = [
  'Stroke & Cerebrovascular', 'Epilepsy & Seizures', "Parkinson's Disease",
  'Memory & Dementia', 'Migraine & Headache', 'Neuropathy',
  'Multiple Sclerosis', 'Sleep Disorders', 'Neuro-infections', 'EEG / NCS / EMG',
  'Neuro-critical Care', 'Movement Disorders',
];

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">

      {/* ── PAGE HERO ── */}
      <section className="page-hero">
        <div className="page-hero-bg-dots" />
        <div className="container">
          <div className="page-hero-content">
            <div className="section-tag">About the Doctor</div>
            <h1 className="page-hero-title">Dr. Rahul Naik</h1>
            <p className="page-hero-sub">
              AIIMS-trained DM Neurologist · Super-Specialist · Naik Neuro Clinic, Nashik
            </p>
          </div>
        </div>
      </section>

      {/* ── DOCTOR PROFILE ── */}
      <section className="about-profile-section">
        <div className="container">
          <div className="about-profile-grid">
            <div className="about-profile-photo-col">
              <div className="doctor-photo-wrap">
                <img src={doctorImg} alt="Dr. Rahul Naik" className="doctor-photo-placeholder" />
                <div className="doctor-badge-card">
                  {/* <div className="badge-card-row">
                    <span className="badge-card-icon"><FaGraduationCap size={18} /></span>
                    <div>
                      <div className="badge-card-label">Highest Qualification</div>
                      <div className="badge-card-val">DM Neurology, AIIMS</div>
                    </div>
                  </div> */}
                  <div className="badge-card-row">
                    <span className="badge-card-icon"><FaHospital size={17} /></span>
                    <div>
                      <div className="badge-card-label">Clinic</div>
                      <div className="badge-card-val">Naik Neuro Clinic, Nashik</div>
                    </div>
                  </div>
                  <div className="badge-card-row">
                    <span className="badge-card-icon"><FaStar size={16} /></span>
                    <div>
                      <div className="badge-card-label">Experience</div>
                      <div className="badge-card-val">10+ Years Super-Specialist</div>
                    </div>
                  </div>
                  <div className="badge-card-row">
                    <span className="badge-card-icon"><FaUsers size={17} /></span>
                    <div>
                      <div className="badge-card-label">Patients Treated</div>
                      <div className="badge-card-val">5000+ Successfully</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-profile-text-col">
              <div className="about-degrees-inline" style={{ marginBottom: 20 }}>
                <span className="degree-pill pill-amber">MBBS (BJMC, Pune)</span>
                <span className="degree-pill pill-teal">MD Internal Medicine</span>
                <span className="degree-pill pill-dark">DM Neurology (AIIMS)</span>
              </div>
              <p style={{ fontSize: 15.5, color: 'var(--text-mid)', lineHeight: 1.85, marginBottom: 18 }}>
                Dr. Rahul Naik is a super-specialist neurologist trained at India's most prestigious medical
                institution — <strong>AIIMS</strong>. With a DM in Neurology and over a decade of
                clinical practice, he brings world-class neurological expertise to Nashik and all of Maharashtra.
              </p>
              <p style={{ fontSize: 15.5, color: 'var(--text-mid)', lineHeight: 1.85, marginBottom: 18 }}>
                His journey in medicine began at <strong>B.J. Medical College, Pune</strong>, followed by an MD in
                Internal Medicine, and culminated in a DM in Neurology from AIIMS — the highest super-specialist
                qualification in Indian medicine.
              </p>
              <p style={{ fontSize: 15.5, color: 'var(--text-mid)', lineHeight: 1.85, marginBottom: 32 }}>
                Known for his <em>patient-first philosophy</em>, Dr. Naik ensures that every consultation is
                unhurried, thorough, and empathetic — making complex neurological conditions understandable and manageable.
              </p>
              <div className="home-about-chips">
                {['Stroke Expert', 'Epilepsy Care', 'Movement Disorders', 'Neuro-diagnostics', 'Migraine Specialist', 'Memory Clinic'].map(c => (
                  <span key={c} className="about-chip">{c}</span>
                ))}
              </div>
              <div style={{ marginTop: 32, display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                <button className="btn-primary" onClick={() => navigate('/contact')}>Book a Consultation</button>
                <button className="btn-secondary" onClick={() => navigate('/services')}>View Services <FaArrowRight size={11} style={{marginLeft:6}} /></button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── QUALIFICATION TIMELINE ── */}
      <section className="about-timeline-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Academic Journey</div>
            <h2 className="section-title">Qualifications & Training</h2>
            <p className="section-desc">A distinguished academic record from India's top medical institutions.</p>
          </div>
          <div className="about-timeline-grid">
            {milestones.map((m, i) => (
              <div key={i} className="timeline-card">
                <div className="timeline-badge">{m.year}</div>
                <h3 className="timeline-place">{m.place}</h3>
                <p className="timeline-note">{m.note}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── AREAS OF EXPERTISE ── */}
      <section className="about-expertise-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Expertise</div>
            <h2 className="section-title">Areas of Specialisation</h2>
            <p className="section-desc">From common to rare — Dr. Naik's expertise spans the full spectrum of neurological conditions.</p>
          </div>
          <div className="about-expertise-grid">
            {expertise.map(s => (
              <div key={s} className="about-service-chip">
                <span className="chip-dot" />
                {s}
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 36 }}>
            <button className="btn-primary" onClick={() => navigate('/services')}>See All Services <FaArrowRight size={12} style={{marginLeft:6}} /></button>
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="home-why">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Why Choose Us</div>
            <h2 className="section-title why-title">Trusted by Thousands in Nashik</h2>
            <p className="section-desc" style={{ color: 'rgba(255,255,255,0.65)' }}>
              What sets Naik Neuro Clinic apart — and why patients travel from across Maharashtra.
            </p>
          </div>
          <div className="reasons-grid reasons-grid-3col">
            {reasons.map(r => (
              <div key={r.title} className="reason-card">
                <div className="reason-icon">{r.icon}</div>
                <h3 className="reason-title">{r.title}</h3>
                <p className="reason-desc">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PATIENT PHILOSOPHY ── */}
      <section className="about-philosophy-section">
        <div className="container">
          <div className="philosophy-card">
            <blockquote className="philosophy-quote">
              Every patient who walks through our doors deserves not just expert treatment —
              but the dignity of a clear explanation, a listening ear, and a plan they can trust.
            </blockquote>
            <div className="philosophy-author">
              <div className="philosophy-author-avatar">RN</div>
              <div>
                <div className="philosophy-author-name">Dr. Rahul Naik</div>
                <div className="philosophy-author-title">DM Neurology (AIIMS) · Naik Neuro Clinic, Nashik</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="cta-banner">
        <div className="container">
          <div className="cta-inner">
            <div className="cta-text">
              <h2 className="cta-title">Ready to Consult Dr. Naik?</h2>
              <p className="cta-sub">Book your appointment today. Available Mon–Sat, Morning & Evening at Naik Neuro Clinic, Nashik.</p>
            </div>
            <div className="cta-actions">
              <button className="cta-btn-primary" onClick={() => navigate('/contact')}>Book Appointment</button>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
